import React from 'react';
import { connect } from 'react-redux';
import * as searchActions from 'actions/learn/search';
import SearchFilter from '../SearchFilter';

const FilterByProgress = ({ selectedProgress, filterByProgress }) => (
  <SearchFilter
    title={t('learn.sidebar.filter.by_progress')}
    value={selectedProgress}
    onChange={filterByProgress}
    name="filterByProgress"
    options={[
      {
        label: t('learn.sidebar.label.everything'),
        value: '',
      },
      {
        label: t('learn.sidebar.label.assigned'),
        value: 'assigned',
      },
      {
        label: t('learn.sidebar.label.viewed'),
        value: 'viewed',
      },
      {
        label: t('learn.sidebar.label.completed'),
        value: 'completed',
      },
    ]}
  />
);

const mapStateToProps = state => ({
  selectedProgress: state.search.filters.progress,
});

const mapDispatchToProps = {
  filterByProgress: searchActions.filterByProgress,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterByProgress);
